// src/contexts/ErrorContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const ErrorContext = createContext();

export const ErrorProvider = ({ children }) => {
    const navigate = useNavigate();
    const [error, setError] = useState(null);
    const [context, setContext] = useState('user'); // Default to 'user'

    useEffect(() => {
        if (error && error.status === 401) {
            console.log("got 401 error here")
            localStorage.clear();
            if (context === 'admin') {
                navigate('/login-admin');
            } else {
                navigate('/login');
            }
            setError(null)
        }
    }, [error, context, navigate]);

    return (
        <ErrorContext.Provider value={{ setError, setContext }}>
            {children}
        </ErrorContext.Provider>
    );
};

export const useError = () => useContext(ErrorContext);
